import { useQuery, UseQueryResult } from 'react-query';
import apiFetch, { defaultApiFetchErrorHandler, HTTPError } from 'react-scale/lib/api-fetch';
import { PayRateType, ReviewLevel } from '@scale/shared/defaults';
import _ from 'lodash';

export function usePayRate(
  projectId?: string,
  userId?: string,
  reviewLevel?: ReviewLevel,
  taskId?: string,

  numTurns?: number,
): UseQueryResult<
  {
    standardRate: number;
    overtimeRate: number;
    payType: string;
    additionalPerTurnRate?: number;
    payPerTaskAssessmentPassBonusRate?: number;
    alreadyPaid?: boolean;
    qualityIncentiveRate?: number;
  },
  unknown
> {
  return useQuery(
    ['payRate', projectId, reviewLevel, userId, taskId, numTurns],
    async () => {
      if (!projectId || !userId || _.isNil(reviewLevel)) {
        return {
          standardRate: 0,
          overtimeRate: 0,
          payType: PayRateType.Hourly,
          additionalPerTurnRate: 0,
          payPerTaskAssessmentPassBonusRate: undefined,
        };
      }
      try {
        const response = await apiFetch(null, `internal/scaler/get_pay_rate`, {
          method: 'GET',
          query: { projectId, userId, reviewLevel, taskId, numTurns },
        });
        return {
          standardRate: response.standardRate,
          overtimeRate: response.overtimeRate,
          payType: response.payType,
          additionalPerTurnRate: response.additionalPerTurnRate,
          payPerTaskAssessmentPassBonusRate: response.payPerTaskAssessmentPassBonusRate,
          alreadyPaid: response.alreadyPaid,
          qualityIncentiveRate: response.qualityIncentiveRate,
        };
      } catch (e) {
        return undefined;
      }
    },
    {
      onError: (err: HTTPError) => defaultApiFetchErrorHandler(err, { handleHttp: true }),
      refetchOnMount: false,
      refetchOnReconnect: false,
      refetchOnWindowFocus: false,
      refetchInterval: false,
      refetchIntervalInBackground: false,
    },
  );
}
